import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class BMO_COLLATERAL_REQUEST_FOR_FUNDS_Mapper extends BaseFormMapper<BMO_COLLATERAL_REQUEST_FOR_FUNDS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: BMO_COLLATERAL_REQUEST_FOR_FUNDS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as BMO_COLLATERAL_REQUEST_FOR_FUNDS);

		return _formData;
	}

	MapValues(): Partial<BMO_COLLATERAL_REQUEST_FOR_FUNDS> {
		return {};
	}
}

const Mappings: BMO_COLLATERAL_REQUEST_FOR_FUNDS = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page1[0]",
	checkboxForwardNoFunds: 'topmostSubform[0].Page1[0].CHK_FORWARD_NOFUNDS[0]',
	checkboxForwardAmount: 'topmostSubform[0].Page1[0].CHK_FORWARD_AMOUNT[0]',
	checkboxForwardFull: 'topmostSubform[0].Page1[0].CHK_FORWARD_FULL[0]',
	// "5":"topmostSubform[0].Page1[0].FAX_NO[0]",
	// "6":"topmostSubform[0].Page1[0].BARCODE_FINAL_REPORT[0]",
	account: 'topmostSubform[0].Page1[0].TRUST_ACCOUNT_NUMBER[0]',
	transit: 'topmostSubform[0].Page1[0].TRUST_ACCOUNT_TRANSIT[0]',
	bank: 'topmostSubform[0].Page1[0].TRUST_ACCOUNT_BANK[0]',
	// "10":"topmostSubform[0].Page1[0].NOTARY_SIGNATURE[0]",
	notaryName: 'topmostSubform[0].Page1[0].NOTARY_NAME[0]',
	branchAddress: 'topmostSubform[0].Page1[0].BMO_BRANCH_ADDRESS[0]',
	totalMortgageFundsRequested:
		'topmostSubform[0].Page1[0].TOTAL_MORTGAGE_FUNDS_REQUESTED[0]',
	trustAccount: 'topmostSubform[0].Page1[0].TRUST_ACCOUNT_INFO_CORRECT[0]',
	fundingDate: 'topmostSubform[0].Page1[0].CLOSING_DATE[0]',
	borrowers: 'topmostSubform[0].Page1[0].BORROWER[0]',
	notaryNumber: 'topmostSubform[0].Page1[0].NOTARY_ID_NUMBER[0]',
	referenceNumber: 'topmostSubform[0].Page1[0].MORTGAGE_NUMBER[0]',
};
export interface BMO_COLLATERAL_REQUEST_FOR_FUNDS {
	notaryNumber: string;
	referenceNumber: string;
	borrowers: string;
	fundingDate: string;
	trustAccount: string;
	bank: string;
	transit: string;
	account: string;
	branchAddress: string;

	checkboxForwardFull: string;
	checkboxForwardAmount: string;
	checkboxForwardNoFunds: string;
	totalMortgageFundsRequested: string;

	notaryName: string;
}
